/* Ocean Native — product card mobile swipe v3.
   Dots tracking + universal drag engine.
   Touch: native scroll-snap is preferred; if the browser claims the pan
   we get a pointercancel and step aside. If a third-party script blocks
   native horizontal scrolling, no pointercancel arrives and we drive
   track.scrollLeft manually so the swipe works regardless.
   Mouse: always manual (browsers don't drag-scroll for mice).
   A drag suppresses the click; a clean tap still navigates. */
(function () {
  if (window.__onCardSwipeV3) return;
  window.__onCardSwipeV3 = true;

  /* ---- dot tracking (delegated; survives AJAX filter re-renders) ---- */
  document.addEventListener(
    'scroll',
    function (e) {
      var track = e.target;
      if (!track || !track.hasAttribute || !track.hasAttribute('data-swipe-track')) return;
      var dots = track.parentNode.querySelectorAll('.grid-product__swipe-dots span');
      if (!dots.length || !track.clientWidth) return;
      var idx = Math.round(track.scrollLeft / track.clientWidth);
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('on', i === idx);
      }
    },
    true
  );

  /* ---- drag engine ---- */
  document.addEventListener('pointerdown', function (e) {
    var track = e.target.closest && e.target.closest('[data-swipe-track]');
    if (!track) return;

    var isMouse = e.pointerType === 'mouse';
    if (isMouse && e.button !== 0) return;
    if (isMouse) e.preventDefault(); // stop native link/image ghost-drag

    var pointerId = e.pointerId;
    var startX = e.clientX;
    var startY = e.clientY;
    var startScroll = track.scrollLeft;
    var manual = false;
    var finished = false;
    var nativeEngaged = false;
    var prevSnap = track.style.scrollSnapType;

    function onTrackScroll() {
      // scroll fired before we went manual => the browser is scrolling natively
      if (!manual) nativeEngaged = true;
    }

    function onMove(ev) {
      if (ev.pointerId !== pointerId || finished) return;
      var dx = ev.clientX - startX;
      var dy = ev.clientY - startY;

      if (!manual) {
        if (nativeEngaged) { cleanup(); return; }        // native has it — step aside
        if (!isMouse && Math.abs(dy) > 14 && Math.abs(dy) > Math.abs(dx)) {
          cleanup();                                      // vertical intent — page scroll
          return;
        }
        var threshold = isMouse ? 5 : 10;
        if (Math.abs(dx) > threshold && Math.abs(dx) > Math.abs(dy) * 1.2) {
          manual = true;
          track.style.scrollSnapType = 'none';            // snap fights manual updates
        } else {
          return;
        }
      }
      track.scrollLeft = startScroll - dx;
    }

    function onUp(ev) {
      if (ev.pointerId !== pointerId || finished) return;
      if (manual) {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
        setTimeout(function () { track.style.scrollSnapType = prevSnap; }, 350);
        // swallow the click so a drag doesn't navigate to the product
        track.addEventListener(
          'click',
          function cancelClick(ce) {
            ce.preventDefault();
            ce.stopPropagation();
            track.removeEventListener('click', cancelClick, true);
          },
          true
        );
      }
      cleanup();
    }

    function onCancel(ev) {
      if (ev.pointerId !== pointerId) return;
      if (manual) track.style.scrollSnapType = prevSnap;
      cleanup();
    }

    function cleanup() {
      finished = true;
      track.removeEventListener('scroll', onTrackScroll);
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onUp);
      document.removeEventListener('pointercancel', onCancel);
    }

    track.addEventListener('scroll', onTrackScroll);
    document.addEventListener('pointermove', onMove);
    document.addEventListener('pointerup', onUp);
    document.addEventListener('pointercancel', onCancel);
  });
})();